export interface ErrorMessage {
  title: string;
  message: string;
}

export type PatternError =
  | 'emailPattern'
  | 'alphaNumPattern'
  | 'phoneNumberPattern'
  | 'datePattern'
  | 'siretPattern'
  | 'hourPattern'
  | 'requiredCompanyName'
  | null;
